export default __webpack_public_path__ + "static/media/pin-verde.0714c0c0.svg";